import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SavedSelection } from '../../models/land';

interface ICountyFips {
  fip: string;
  name: string;
  fullname: string;
}

interface IStateFips {
  fip: string;
  name: string;
  state_abbreviation: string;
}

type ClaimMyLandInfo = {
  address: string;
  county: ICountyFips;
  name: string;
  state: IStateFips;
  apn: string;
};

interface InitialState {
  isModalOpen: boolean;
  claimMyLandInfo: ClaimMyLandInfo;
  isSelectingLand: boolean;
  hasFinishedSelectingLand: boolean;
  hasFinishedEditingLand: boolean;
  isEditing: boolean;
  currentClaim: SavedSelection | null;
  isClaimingLand: boolean;
}

interface IEditingClaimPayload {
  isEditing: boolean;
  data: SavedSelection;
}

const initialState: InitialState = {
  claimMyLandInfo: {
    address: '',
    apn: '',
    county: {
      fip: '',
      fullname: '',
      name: '',
    },
    name: '',
    state: {
      fip: '',
      name: '',
      state_abbreviation: '',
    },
  },
  currentClaim: null,
  hasFinishedEditingLand: false,
  hasFinishedSelectingLand: false,
  isClaimingLand: false,
  isEditing: false,
  isModalOpen: false,
  isSelectingLand: false,
};

const claimMyLandSlice = createSlice({
  initialState,
  name: 'claim-my-land',
  reducers: {
    clearClaimMyLand: (state) => {
      state.claimMyLandInfo = initialState.claimMyLandInfo;
      state.isSelectingLand = initialState.isSelectingLand;
      state.hasFinishedSelectingLand = initialState.hasFinishedSelectingLand;
      state.hasFinishedEditingLand = initialState.hasFinishedEditingLand;
      state.isModalOpen = initialState.isModalOpen;
      state.isEditing = initialState.isEditing;
      state.isClaimingLand = initialState.isClaimingLand;
    },
    clearCurrentClaim: (state) => {
      // state.currentClaim = initialState.currentClaim;
      state.hasFinishedEditingLand = initialState.hasFinishedEditingLand;
    },
    setClaimMyLandInfo: (state, action: PayloadAction<ClaimMyLandInfo>) => {
      state.claimMyLandInfo = action.payload;
    },
    setHasFinishedClaiming: (state) => {
      state.isClaimingLand = false;
    },
    setHasFinishedEditingLand: (state) => {
      state.hasFinishedEditingLand = true;
      state.isEditing = false;
      state.isModalOpen = false;
    },
    setHasFinishedSelectingLand: (state) => {
      state.hasFinishedSelectingLand = true;
      state.isSelectingLand = false;
      state.isModalOpen = true;
    },
    setIsEditingLand: (state, action: PayloadAction<IEditingClaimPayload>) => {
      state.isEditing = action.payload.isEditing;
      state.currentClaim = action.payload.data;
      state.isModalOpen = false;
      state.isClaimingLand = true;
    },
    setIsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
      state.isClaimingLand = true;
      state.isSelectingLand = false;
    },
    setIsSelectingLand: (state, action: PayloadAction<boolean>) => {
      state.isSelectingLand = action.payload;
      state.isModalOpen = false;
      state.isClaimingLand = true;
    },
  },
});

/** @deprecated */
export const {
  clearClaimMyLand,
  setClaimMyLandInfo,
  setHasFinishedSelectingLand,
  setIsModalOpen,
  setIsSelectingLand,
  setHasFinishedEditingLand,
  setIsEditingLand,
  clearCurrentClaim,
  setHasFinishedClaiming,
} = claimMyLandSlice.actions;

/** @deprecated */
export default claimMyLandSlice.reducer;
